<template>
  <transition name="fade">
    <div
      v-if="_.get($store.state.main.selected_menu, 'id')"
      class="page-wrapper"
      @keydown.tab="pressTab($event)"
    >
      <component
        :is="selectedLayout"
        :key="selectedLayout"
        v-if="selectedLayout"
      />
    </div>
  </transition>
</template>

<script>
import mainMixin from "@/mixins/main";
import pageRouting from "@/mixins/pageRouting";

export default {
  name: "App",
  mixins: [mainMixin, pageRouting],
  components: {},
  metaInfo() {
    const innerSeo = _.get(
      this.$store.state.main.current_content,
      `primary.data.list[0].seo_title_${this.$store.state.main.locale}`
    );
    const website_title = _.get(
      this.$store.state.main.indx,
      "siteSettings.website_title"
    );

    let contentTitle =
      innerSeo ||
      _.get(this.$store.state.main.selected_menu, "seo.title") ||
      _.get(this.$store.state.main.selected_menu, "title");

    if (!innerSeo && Object.values(this.$route.params).includes("singleview")) {
      contentTitle = _.get(
        this.$store.state.main.current_content,
        "primary.data.list[0].title"
      );
    }
    const description =
      _.get(this.$store.state.main.selected_menu, ["seo", "description"]) ||
      _.get(
        this.$store.state.main.indx,
        "siteSettings.website_meta_description"
      );
    const keyword =
      _.get(this.$store.state.main.selected_menu, ["seo", "keywords"]) ||
      _.get(this.$store.state.main.indx, "siteSettings.website_meta_keywords");
    // if no subcomponents specify a metaInfo.title, this title will be used
    return {
      title: contentTitle,
      // all titles will be injected into this template
      titleTemplate: "%s | " + website_title,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: description
        },
        {
          vmid: "keyword",
          name: "keyword",
          content: keyword
        }
      ]
    };
  },
  data() {
    return {
      selectedLayout: "",
      tabPressed: false
    };
  },

  mounted() {
    if (!_.size(_.get(this.$store.state, "cache.servicesMap"))) {
      this.$store.dispatch("main/getBulkData", {
        node: "servicesMap",
        key: "servicesMap"
      });
    }

    if (this.$route.name && this.$route.name.indexOf("PageViewRouter") >= 0)
      this.$store.commit("main/setState", { key: "showSite", val: true });
  },

  watch: {
    "$store.state.cache": {
      immediate: true,
      deep: true,
      handler() {
        // console.log(111, this.$store.state.main.cache);
      }
    },

    $route: {
      immediate: true,
      deep: true,
      handler: function() {
        this.pageRoutingSelectMenuByPath();
        if (this.$route.name === "PageViewRouter_ge") {
          document.querySelector("html").setAttribute("lang", "ka");
        } else {
          document.querySelector("html").setAttribute("lang", "en");
        }
      }
    },

    "$store.state.main.selected_menu.id": {
      immediate: true,
      handler() {
        // console.log('state.main.selected_menu.id');
        this.importLayouts();
        this.pageRoutingSelectMenuByPath();
        this.setLayoutTemplate();
      }
    },

    "$store.state.main.indx.smartLayouts": {
      immediate: true,
      handler() {
        this.importLayouts();
        this.pageRoutingSelectMenuByPath();
        this.setLayoutTemplate();

        // console.log(this.selectedLayout, this.$store.state.main.selected_menu );
      }
    }
  },

  methods: {
    importLayouts() {
      /// dinamicaly import all layouts as components
      let components = _.get(this.$store.state.main.indx, "smartLayouts");

      for (let i in components) {
        this.$options.components[i] = () => import("./views/layouts/" + i);
      }
      return true;
    },

    pressTab(event) {
      if (document.body.classList.contains("active")) {
        return;
      } else {
        this.tabPressed = true;
        document.body.classList.add("active");
        this.$store.commit("main/accessiblityModal");
      }
    },

    /// set layout template depend on selected_menu.currentLayoutTemplate
    setLayoutTemplate() {
      if (
        this.$options.components[
          _.get(this.$store.state.main.selected_menu, "currentLayoutTemplate")
        ]
      ) {
        this.selectedLayout = this.$store.state.main.selected_menu.currentLayoutTemplate;
      }
    }
  }
};
</script>
<style>
.page-wrapper {
  overflow: hidden;
}
</style>
